import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router/index.js';
import './styles/main.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.config.errorHandler = (error, _instance, info) => {
  console.error('Unerwarteter Fehler in der Oberfläche:', error, info);
};

app.mount('#app');
